'use strict'

export default [
  {
    name:"output",
    fields: [
      { name: "output", height:3, },
      { name: "qualityExpectation", height:3 },
    ]
  }, {
    name: "acceptance",
    fields: [
       { name: "acceptanceCriteria", height:3 },
       { name: "acceptanceMethod", height: 3 },
       { name: "acceptanceResponsible", height: 3 },
     ]
  }, {
    name: "dependencies",
    fields: [
      { name: "derivation", height: 3 },
      { name: "skills", height: 3 },
    ]
  }
];



// WEBPACK FOOTER //
// ./views/quality/outputFormDefinition.js